module.exports = __webpack_public_path__ + "img/sr.ba3c45c0.svg";